import React, { ButtonHTMLAttributes } from 'react';
import { Icon } from 'src/components/Icons';
import { Circle } from './CircleButton.styles';
import { t } from 'i18next';

interface ICircleButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconType?: 'ok' | 'delete' | 'refresh' | 'pencil';
  iconAltText?: string;
}

const CircleButton = ({
  children,
  iconAltText,
  iconType,
  ...buttonProps
}: ICircleButton) => {
  return (
    <Circle {...buttonProps}>
      {iconType ? <Icon type={iconType} aria-label={iconAltText} /> : null}
      {iconType === 'delete' ? (
        <span style={{ display: 'none' }}>{t('Delete')}</span>
      ) : null}
      {children}
    </Circle>
  );
};

export default CircleButton;
